import '../../styles-new/pages/olympiad/olympiad-home.scss';

(function () {
  // Target date: February 6, 2026
  const targetDate = new Date('2026-02-06T00:00:00');

  function updateCountdown() {
    const now = new Date();
    const difference = targetDate - now;

    if (difference <= 0) {
      // Olympics have started
      document.getElementById('countdown-days').textContent = '00:';
      document.getElementById('countdown-hours').textContent = '00:';
      document.getElementById('countdown-minutes').textContent = '00:';
      document.getElementById('countdown-seconds').textContent = '00';
      return;
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);

    document.getElementById('countdown-days').textContent = String(days).padStart(2, '0') + ':';
    document.getElementById('countdown-hours').textContent = String(hours).padStart(2, '0') + ':';
    document.getElementById('countdown-minutes').textContent = String(minutes).padStart(2, '0') + ':';
    document.getElementById('countdown-seconds').textContent = String(seconds).padStart(2, '0');
  }

  // Update immediately
  updateCountdown();

  // Update every second
  setInterval(updateCountdown, 1000);

  // Schedule slider functionality
  const scheduleSlider = document.querySelector('.schedule-slider');
  if (scheduleSlider) {
    const track = scheduleSlider.querySelector('.schedule-slider__track');
    const slides = scheduleSlider.querySelectorAll('.schedule-slider__slide');
    const prevButtons = scheduleSlider.querySelectorAll('.schedule-card__arrow--prev');
    const nextButtons = scheduleSlider.querySelectorAll('.schedule-card__arrow--next');
    const titleElement = scheduleSlider.querySelector('.schedule-card__title');
    const dateElement = scheduleSlider.querySelector('.schedule-card__date-text');
    
    let currentSlide = 0;
    const totalSlides = slides.length;

    function updateSlider() {
      const offset = -currentSlide * 100;
      track.style.transform = `translateX(${offset}%)`;
      
      // Update header with current slide data
      const currentSlideElement = slides[currentSlide];
      if (currentSlideElement) {
        const date = currentSlideElement.dataset.date;
        const title = currentSlideElement.dataset.title;
        
        if (dateElement) {
          dateElement.textContent = date;
        }
        if (titleElement) {
          titleElement.textContent = title;
        }
      }
      
      // Update arrow states
      prevButtons.forEach(btn => {
        btn.disabled = currentSlide === 0;
        btn.style.opacity = currentSlide === 0 ? '0.5' : '1';
      });
      nextButtons.forEach(btn => {
        btn.disabled = currentSlide === totalSlides - 1;
        btn.style.opacity = currentSlide === totalSlides - 1 ? '0.5' : '1';
      });
    }

    function goToSlide(index) {
      if (index >= 0 && index < totalSlides) {
        currentSlide = index;
        updateSlider();
      }
    }

    function nextSlide() {
      if (currentSlide < totalSlides - 1) {
        goToSlide(currentSlide + 1);
      }
    }

    function prevSlide() {
      if (currentSlide > 0) {
        goToSlide(currentSlide - 1);
      }
    }

    // Add event listeners to all arrow buttons
    prevButtons.forEach(btn => {
      btn.addEventListener('click', prevSlide);
    });
    nextButtons.forEach(btn => {
      btn.addEventListener('click', nextSlide);
    });

    // Initialize
    updateSlider();
  }
})();